<app-modal-container>
  <header header>
    <div class="flex w-full justify-end p-4 items-center">
      <button (click)="close()" class="cursor-pointer flex items-center">
        <app-icon name="material-symbols:close" class="size-5! text-zinc-400" />
      </button>
    </div>
  </header>

  <div class="flex flex-col gap-6 lg:gap-3 w-full h-full items-center justify-center p-4">
    <app-icon name="material-symbols:check-circle" class="size-5! text-zinc-800" />
    <h3 class="text-lg font-semibold text-zinc-800 text-center">문의 신청 완료</h3>

    <div class="w-full bg-zinc-50 rounded-xl p-5 lg:p-3 flex flex-col gap-2">
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">문의자명</span>
        <span class="text-sm text-zinc-800 font-medium">{{ name() }}</span>
      </div>
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">연락처</span>
        <span class="text-sm text-zinc-800 font-medium">{{ contact() }}</span>
      </div>
    </div>

    <div class="text-center">
      <p class="text-sm text-zinc-500">문의 내용이 성공적으로 접수되었습니다.</p>
      <p class="text-sm text-zinc-500">담당자가 확인 후 입력하신 연락처로 빠르게 회신드리겠습니다.</p>
    </div>
  </div>

  <footer footer class="w-full p-4">
    <button
      routerLink="/"
      (click)="close(true)"
      class="cursor-pointer w-full bg-zinc-800 text-white font-medium py-2 px-3 rounded-xl">
      홈으로
    </button>
  </footer>
</app-modal-container>
